/*
  Custom JS code.
*/
document.addEventListener("DOMContentLoaded", function () {
  const botaoParcelamento = document.querySelector(".parcelamento-btn");
  const tabelaParcelas = document.querySelector(".parcelamento-box");

  if (botaoParcelamento && tabelaParcelas) {
    botaoParcelamento.addEventListener("click", function () {
      tabelaParcelas.style.display =
        tabelaParcelas.style.display === "block" ? "none" : "block";
    });
  }
});
if (typeof Shopify.formatMoney !== "function") {
  Shopify.formatMoney = function (cents) {
    const value = (cents / 100).toFixed(2);
    const currency = Shopify.currency.active || "R$";
    return currency + " " + value.replace(".", ",");
  };
}
